import { render, staticRenderFns } from "./ComponentDetail.vue?vue&type=template&id=52132bfd&scoped=true"
import script from "./ComponentDetail.vue?vue&type=script&lang=js"
export * from "./ComponentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52132bfd",
  null
  
)

/* custom blocks */
import block0 from "@/components/CoreComponent/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FCoreComponent%2FComponent%2FComponentDetail.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports